import { Icon } from "@mdotm/shadcn/legacy/components";
import { Button } from "@mdotm/shadcn/mdotm/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";

/**
 * The control that opens a `DatePickerPopover`: the current day with a caret beside it.
 *
 * It renders the button and nothing around it, so that a caller can hand it straight to the popover
 * as the `asChild` trigger — a wrapper element there would take the click and the ref instead. Every
 * prop the popover injects rides through, which is also what lets a caller render this button on its
 * own, with no popover behind it, when there is nothing to pick.
 */
export function DatePickerTriggerButton({
	label,
	ariaLabel,
	disabled,
	qualifier,
	...triggerProps
}: {
	/** What the button reads: the chosen day, or the caller's word for "unset". */
	label: string;
	/** What the button announces — which is what pressing it does, where `label` says where you are. */
	ariaLabel: string;
	disabled?: boolean;
	qualifier: string;
} & Omit<
	React.ComponentProps<"button">,
	"children" | "aria-label" | "disabled" | "className" | "size" | "data-qualifier"
>): React.JSX.Element {
	return (
		<Button
			{...triggerProps}
			palette="ghost"
			size="x-small"
			className="justify-between"
			disabled={disabled}
			aria-label={ariaLabel}
			data-qualifier={qualifier}
		>
			{label}&nbsp;
			<Icon icon="Down" color={disabled ? themeCSSVars.palette_N300 : themeCSSVars.palette_N700} size={14} />
		</Button>
	);
}
